import { render, staticRenderFns } from "./ReleasePassedRate.vue?vue&type=template&id=f5144162&scoped=true"
import script from "./ReleasePassedRate.vue?vue&type=script&lang=js"
export * from "./ReleasePassedRate.vue?vue&type=script&lang=js"
import style0 from "./ReleasePassedRate.vue?vue&type=style&index=0&id=f5144162&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5144162",
  null
  
)

export default component.exports